﻿import * as odpUtils from '../integrations/ODP/utils';
if ($(".configured-bundle").length > 0) {
    var bundleOrPackageJson = $("#bundleOrPackageJson").val();
    var configuredBundleId = $("#bundleOrPackageJson").attr("data-code");
    var bundleOrPackagesDetailsObject = JSON.parse(bundleOrPackageJson);
    var selectedMaterials = [];
    var selectedBundle = "";
    var nextCategoryIndex = 0;
    var totalPrice = 0;

    $(document).on("change", ".custom-select", function () {
        var index = $(this).parent().parent().index();
        console.log("Index value", index);

        var selectedValue = $(this).val();
        console.log('Selected Value', selectedValue);
        console.log('Bundle Or Packages Details Object', bundleOrPackagesDetailsObject);

        if (selectedValue && selectedValue != "Select") {
            if (index == 0) {
                if (selectedBundle !== ""){
                    $(".bp-detail-page__categories .row .col-4").slice(1).remove();
                    selectedMaterials = [];
                    totalPrice = 0;
                }

                nextCategoryIndex = 0;
                selectedBundle = selectedValue;
            }

            selectedMaterials.push($(this).find(':selected').attr('data-materialid'));
            totalPrice = parseFloat(totalPrice) + parseFloat($(this).find(':selected').attr('data-price'));
            totalPrice = totalPrice.toFixed(2);

            console.log('Total Price', totalPrice)
            console.log("Selected Materials", selectedMaterials);

            showPricing();
            var required = "";

         
            let nextCategory = [];
            let dropdownElements = [];

            $.each(bundleOrPackagesDetailsObject, function (i) {
                    if (bundleOrPackagesDetailsObject[i].CategoryDropdowns.length != nextCategoryIndex) {
                            required = "";
                            nextCategory.push(bundleOrPackagesDetailsObject[i].CategoryDropdowns[nextCategoryIndex]);
                            if (nextCategory) {
                                if (nextCategory.Required) {
                                    required = "required";
                                    $(".bp-detail-page__top-cta-container .add-to-cart-configured").prop("disabled", true);
                                }
                                $.each(nextCategory[0].Details, function (j) {
                                    dropdownElements.push(bundleOrPackagesDetailsObject[i].CategoryDropdowns[nextCategoryIndex]);
                                })
                            }
                            nextCategoryIndex++;
                    }
                   
            })
            if (nextCategory === undefined) {
                return;
            }
           
            console.log('Next Category', nextCategory);
            $.grep(nextCategory, function (element) {
                var optionsHtml = "";
                $.grep(element.Details, function (element) {
                        optionsHtml += '<option data-materialid="' + element.MaterialId + '" data-price="' + element.Price + '">' + element.Value + '</option>';
                    });
                $(".bp-detail-page__categories .row").append('<div class="col-4 drop-down"><div class="form-group--float-label float-active"><label for="' + element.Category + '" id="' + element.Category + '">' + element.Category + '<span class="dropdown-name">*</span></label> <select ' + required + ' name="' + element.Category + '" id="' + element.Category + '" class="mb-2 custom-select"><option value="">Select</option> ' + optionsHtml + '</select></div></div>');
            })
            if (validateDropdowns()) {
                $(".bp-detail-page__top-cta-container .add-to-cart-configured").prop("disabled", false);
            }
        }
        else{
            $(".bp-detail-page__categories .row .col-4").slice(1).remove();
            $(".bp-detail-page__categories .row .col-4 .custom-select").val('Select')
            $(".bp-detail-page__top-cta-container .add-to-cart-configured").prop("disabled", true);
            selectedBundle = '';
            selectedMaterials = [];
            nextCategoryIndex = 0;
            totalPrice = 0;
            showPricing();
        }
    });

    function showPricing() {
        $(".bp-detail-page__price-container").removeClass("d-none");
        $(".bp-detail-page__price-container #bp-custom-price").html("$" + totalPrice);
        
    }

    $(".add-to-cart-configured").click(function () {
        addToCartConfigured();
    })

    function addToCartConfigured() {
        var qty = $(".bp-detail-page__top-cta-container #quantity").val();
    
        var data = {
            materialList: selectedMaterials,
            configuredBundleOrPackageId: configuredBundleId,
            quantity: qty,
        };
        odpUtils.TrackAddConfiguredBundleToCart(configuredBundleId);
        const addBundleToCartEvent = new CustomEvent('add-configured-bundle-to-cart', { detail: { data } });
        window.dispatchEvent(addBundleToCartEvent);
        $("#mini-cart").css('display', 'block');
    }
}


$(".bp-detail-page__qty-decrement").click(function () {
    var quantity = $(".bp-detail-page__top-cta-container #quantity").val();
    $(".bp-detail-page__top-cta-container #quantity").val(parseInt(quantity) - 1);
})

$(".bp-detail-page__qty-increment").click(function () {
    var quantity = $(".bp-detail-page__top-cta-container #quantity").val();
    $(".bp-detail-page__top-cta-container #quantity").val(parseInt(quantity) + 1);
})

$(".bp-detail-page .add-to-cart").click(function () {
    addToCart();
})

$(".bundles-packages .add-to-cart,.bundles-packages.add-to-cart").click(function () {
    addToCartPFP(this);
})

function validateDropdowns() {
    var isValid = true;

    $.each(bundleOrPackagesDetailsObject, function (i) {
        var anyCategoryIsRequired = $.grep(bundleOrPackagesDetailsObject[i].CategoryDropdowns, function (element) {
            return element.Required == true;
        }).length > 0;
        if (anyCategoryIsRequired) {
            $.grep(bundleOrPackagesDetailsObject[i].CategoryDropdowns, function (element) {
                if (element.Required) {
                    console.log($('.bp-detail-page__categories select[name="Primary Module"]').val());
                    if ($('.bp-detail-page__categories select[name="' + element.Category + '"]').val() == '') {
                        isValid = false;
                    }
                }
            });
        }
    });
   

    return isValid;
}
function addToCart() {
    var qty = $(".bp-detail-page__top-cta-container #quantity").val();

    var data = {
        materialList: null,
        configuredBundleOrPackageId: $("#bundle-code").val(),
        quantity: qty,
    };

    //ODP event
    odpUtils.TrackAddBundleToCart(data.configuredBundleOrPackageId);

    const addBundleToCartEvent = new CustomEvent('add-bundle-to-cart', { detail: { data } });
    window.dispatchEvent(addBundleToCartEvent);
    $("#mini-cart").css('display', 'block');
}

function addToCartPFP(event) {
    var qty = $(event).parent().parent().find("input[name='qty']").val();

    var data = {
        materialList: null,
        configuredBundleOrPackageId: $(event).attr("data-materialid"),
        quantity: qty,
    };

    //ODP event
    odpUtils.TrackAddBundleToCart(data.configuredBundleOrPackageId);

    const addBundleToCartEvent = new CustomEvent('add-bundle-to-cart', { detail: { data } });
    window.dispatchEvent(addBundleToCartEvent);
    $("#mini-cart").css('display', 'block');
}